import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { from, Observable, of } from 'rxjs'; 
import { catchError, map } from 'rxjs/operators'; 
import * as EmployeeModels from '@employee-models/index';
import * as SharedModels from '@ui-app/models';
import {RoutesConfig} from '@employee-configs/routes.config';
import { EmployeeDataAccessService } from '../services/data-access.service';


@Injectable({
    providedIn: 'root'
})
export class EmployeeSearchGaurd implements CanActivate {

    constructor(
        private router: Router,
        private employeeDataAccessService: EmployeeDataAccessService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean | Promise<boolean> {
        const requiredRolesIds: Array<EmployeeModels.DE.UserRoleEnum> = route.data.rolesIds || null;

        const userEmail = sessionStorage.getItem('userEmail'); 
        if (userEmail) { 

        // If userEmail exists, check access rights 
        return this.employeeDataAccessService.userData.getUserAccesForEmployeeSearch(userEmail).pipe( 
            map(response => { 
                // Assuming the response directly indicates access permission (true/false) 
                return response; 
            }), 
            catchError(error => { 
                // Handle any error, possibly by logging and returning an observable of false 
                console.error('Error checking access for employee search', error); 
                return of(false); // Return Observable<boolean> indicating denied access 
            }) 
        ); 
        } else { 
                // If userEmail does not exist, navigate to access denied page and return false 
                return from(this.router.navigate([RoutesConfig.general.accessDeniedPage])).pipe( 
                map(() => false) // Convert the promise from navigate to an observable of false 
                ); 
        }
    }

}
